import { homedir } from 'node:os';
import { join, resolve } from 'node:path';
export const iloHome = (env = process.env) => {
    if (env.ILO_HOME?.trim())
        return resolve(env.ILO_HOME.trim());
    const configHome = env.XDG_CONFIG_HOME?.trim() || join(homedir(), '.config');
    return join(configHome, 'ilo');
};
export const iloConfigPath = (env) => join(iloHome(env), 'config.json');
export const iloDatabasePath = (env) => join(iloHome(env), 'ilo.sqlite');
//# sourceMappingURL=paths.js.map